import { Component, OnInit } from '@angular/core';
import { DestroyService } from '../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { CustomerFilterModel, CustomerModel } from '../../../shared/service-proxies/event-service-proxy';
import { CustomerHelperService } from '../../services/customer-helper/customer-helper.service';

@Component({
  selector: 'app-search-bar',
  standalone: false,
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  providers: [DestroyService],
})
export class SearchBarComponent implements OnInit {

  private customerFilter: CustomerFilterModel = new CustomerFilterModel();
  public customers: CustomerModel[] = [];
  pageSize: number = 10;

  constructor(private destroyService: DestroyService, private customerHelper: CustomerHelperService,) { }
  
  ngOnInit(): void {
    this.getCustomers();
  }

  searchCustomers(searchText: string) {
    if (!searchText.trim()) {
      this.getCustomers(); 
      return;
    }
    this.customerHelper
      .searchCustomers(searchText, this.pageSize)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((customers) => {
        this.customers = customers.map(c => {
          const customerInstance = Object.assign(new CustomerModel(), c.customer);
          customerInstance['matches'] = c.matches; 
          return customerInstance;
        });
      });
  }
  getCustomers() {
  this.customerFilter.perPage = this.pageSize;
  this.customerHelper
    .getCustomers(this.customerFilter)
    .pipe(takeUntil(this.destroyService.onDestroy$))
    .subscribe((customers) => {
      this.customers = customers.map(customer => {
        const customerInstance = Object.assign(new CustomerModel(), customer);
        customerInstance['matches'] = {}; 
        return customerInstance;
      });
    }, error => {
      console.error('Error fetching customers:', error);
    });
}
}
